import ScrollUtils from 'utils/scrollUtils'
import UrlParams from 'utils/UrlParams'
import * as Sentry from '@sentry/vue'
import OrigDestUtils from 'store/utils/eHorizonOrigDestUtils'
import getNearestAirport from 'utils/GetNearestAirport'
import CookieUtils from 'utils/CookieUtils'
import OrigDest from 'utils/OrigDestData'
import SearchFormStore from 'store/modules/eHorizon/SearchForm/SearchForm'
import FsfStore from 'store/modules/eHorizon/SearchForm/Fsf'
import OriginMixin from 'components/eHorizon/SearchFormMixins/Origin'
import DestinMixin from 'components/eHorizon/SearchFormMixins/Destin'
import { mapState } from 'vuex'
import Pimcore from 'services/AirBaltic/Pimcore'
import gtmFSF from 'services/AirBaltic/GTM/FSF'
import FlightSearchApi from 'services/AirBaltic/FlightSearchForm/FlightSearch'

const FormMixin = {
  data() {
    return {
      responseStatus: '',
      fsfOrigDest: {}
    }
  },

  mixins: [OriginMixin, DestinMixin],

  created() {
    this.getOrigDestData()
  },

  computed: {
    ...mapState({
      selectedLang: (state) => state.main.selectedLang,
      openFsfOvl: (state) => state.indexTabs.openFsfOvl,
      destin: (state) => state.eHorizonSearchForm.destin,
      origin: (state) => state.eHorizonSearchForm.origin,
      origDestData: (state) => state.eHorizonSearchForm.origDestData,
      value: (state) => state.eHorizonSearchForm.origin.value
    })
  },

  methods: {
    $_fsfMixin_openOnLoad() {
      let openTab = UrlParams.getUrlParam(window.location.href, 'opentab')

      if (this.openFsfOvl || openTab?.toUpperCase() === 'OVL' || window.location.hash.includes('selectdates')) {
        this.$_fsfMixin_openFsfModal(true)
      }
    },
    getOrigDestData() {
      if (!this.$store.hasModule('eHorizonSearchForm')) {
        this.$store.registerModule('eHorizonSearchForm', SearchFormStore)
      }

      const int = setInterval(() => {
        if (
          this.$store.hasModule('eHorizonSearchForm') &&
          typeof origDestData !== 'undefined'
        ) {
          this.initOrigDestData()
          clearInterval(int)
        }
      }, 20)
    },

    initOrigDestData() {
      if (typeof origDestLabels !== 'undefined') {
        this.$store.commit(`eHorizonSearchForm/destin/setLabels`, origDestLabels)
      }

      if (typeof origDestData !== 'undefined') {
        const data = OrigDest.parseData(origDestData)

        this.$store.commit(`eHorizonSearchForm/setOrigDestData`, data)
        this.$store.commit(
          `eHorizonSearchForm/origin/setDestinations`,
          OrigDestUtils.prepareData(data).filter((o) => o.isOrig)
        )

        const nearestAirport = getNearestAirport()
        if (
          nearestAirport &&
          typeof data[nearestAirport] !== 'undefined' &&
          !Object.keys(this.value).length
        ) {
          this.$store.dispatch(`eHorizonSearchForm/selectOrigin`, data[nearestAirport])
        }
      }

      const country = CookieUtils.getCookie('country') || null
      if (country) {
        this.$store.dispatch('eHorizonSearchForm/origin/setHomeCountry', country)
      }
    },

    $_fsfMixin_originCategories() {
      return this.origin.homeCountry
        ? {
            nearby: 'searchForm.originDestin.origin.labels.nearbyOrigins',
            countries: 'searchForm.originDestin.origin.labels.countries',
            all: 'searchForm.originDestin.origin.labels.allOrigins'
          }
        : {
            popular: 'searchForm.originDestin.origin.labels.popularOrigins',
            countries: 'searchForm.originDestin.origin.labels.countries',
            all: 'searchForm.originDestin.origin.labels.allOrigins'
          }
    },
    $_fsfMixin_destinCategories() {
      return {
        all: 'searchForm.originDestin.destin.labels.allDestinations',
        countries: 'searchForm.originDestin.destin.labels.countries',
        interests: 'searchForm.originDestin.destin.labels.interests'
      }
    },

    $_fsfMixin_onOriginCategorylUpdate(value) {
      this.$store.commit('eHorizonSearchForm/origin/setSelectedCategory', value)
    },
    $_fsfMixin_onOriginSubCategorylUpdate(value) {
      let selectedSubCatValue = value.country || value
      this.$store.commit(
        'eHorizonSearchForm/origin/setSelectedSubCategory',
        selectedSubCatValue
      )
    },
    $_fsfMixin_onDestinCategorylUpdate(value, position = null) {
      this.$store.commit('eHorizonSearchForm/destin/setSelectedCategory', value)

      if (position) {
        gtmFSF.selectedLabel(value, position)
      }
    },
    $_fsfMixin_onDestinSubCategorylUpdate(value, position = null) {
      let selectedSubCatValue = value.country || value
      let selectedSubCatLabel = value.code || value
      this.$store.commit(
        'eHorizonSearchForm/destin/setSelectedSubCategory',
        selectedSubCatValue
      )
      this.$store.commit(
        'eHorizonSearchForm/destin/setSelectedSubCategoryLabel',
        selectedSubCatLabel
      )

      if (position) {
        const selectedCat = this.$store.state.eHorizonSearchForm.destin.selectedCategory
        gtmFSF.selectedSubLabel(selectedSubCatLabel, selectedCat, position)
      }
    },

    $_fsfMixin_typeaheadOpenOrigin(isMobile) {
      if (isMobile) {
        ScrollUtils.disableScroll()
      }
      this.showOriginTypeahead()
    },

    $_fsfMixin_typeaheadOpenDestin(isMobile, gtmLabel = null) {
      if (isMobile) {
        ScrollUtils.disableScroll()
      }
      this.onDestinFocused(gtmLabel)
    },

    $_fsfMixin_typeaheadCloseOrigin(openBl, enableScroll) {
      if (enableScroll) {
        ScrollUtils.enableScroll()
      }
      this.onOriginOpenUpdate(openBl)
    },

    $_fsfMixin_typeaheadCloseDestin(openBl, enableScroll) {
      if (enableScroll) {
        ScrollUtils.enableScroll()
      }
      this.onDestinOpenUpdate(openBl)
    },

    $_fsfMixin_selectOrigin(value, resetSession) {
      this.onOriginSelect(value, true, resetSession)
      if (resetSession) {
        ScrollUtils.enableScroll()
      }
    },
    $_fsfMixin_selectDestin(value, resetSession) {
      this.onDestinSelected(value, true, resetSession)
    },
    $_fsfMixin_initFsfModal() {
      if (!this.$store.hasModule('fsf')) {
        this.$store.registerModule('fsf', FsfStore)
      }
    },
    $_fsfMixin_openFsfModal(
      skipGtmOpenedPush = false,
      ignoreSessionStorage = false,
      setDataFromStore = false
    ) {
      if (this.$store.state.main.modal.isModalOpened) return
      window.location.hash = 'selectdates'

      this.$store.commit('main/showPlaneLoader', true)
      let props

      props = {
        disableCloseOnClickOutside: false,
        ignoreSessionStorage: ignoreSessionStorage,
        setDataFromStore,
        showHeader: false
      }

      const fsfModal = import(
        /* webpackChunkName: "fsf-modal" */ 'components/FlightSearchForm/Modal/FsfModal.vue'
      )
      fsfModal
        .then((result) => this.$_fsfMixin_componentLoaded(result, skipGtmOpenedPush))
        .catch((e) => this.$_fsfMixin_componentFailed(e))

      this.$store.commit('main/setModalCloseFn', this.$_fsfMixin_closeModalFunction)
      this.$store.commit('main/setModalProps', props)

      this.$store.commit('main/setShowModalHeader', false)
    },

    $_fsfMixin_componentLoaded(result, skipGtmFsf) {
      this.$store.commit('main/setModalContent', result.default)
      this.$store.dispatch('main/openFsfModal')

      if (skipGtmFsf) return
      gtmFSF.overlayOpened(this.$store.state.eHorizonSearchForm)
    },

    $_fsfMixin_componentFailed(e) {
      this.$store.commit('main/setShowCloseIcon', true)
      this.$store.dispatch('main/openModal')
      this.$store.commit('main/showPlaneLoader', false)
      Sentry.captureException(e)
    },

    $_fsfMixin_closeModalFunction() {
      ScrollUtils.enableScroll()
      window.location.hash = ''
      this.$store.dispatch('main/closeModal')
    },
    $_fsfMixin_onSubmitForm() {
      gtmFSF.flightSearchOverlay('flight_search', this.$store.state.eHorizonSearchForm)
    },
    $_fsfMixin_createDeeplink(fullLink = false) {
      let url = new URL(`https://${window.location.hostname}${window.location.pathname}?`)
      let params = new URLSearchParams(url.search)

      params.append('opentab', 'OVL')
      params.append('sref', 'WPU')

      if (this.pos) {
        params.append('pos', this.pos)
      }

      if (this.calendar.departureDate && fullLink) {
        params.append('departure', this.calendar.departureDate)
      }

      if (this.calendar.returnDate && fullLink) {
        params.append('return', this.calendar.returnDate)
      }

      params.append('l', this.selectedLang)

      if (this.origin.value.code) {
        params.append('originCode', this.origin.value.code)
      }

      if (this.origin.value.type) {
        params.append('originType', this.origin.value.type)
      }

      if (this.destin.value.code) {
        params.append('destinCode', this.destin.value.code)
      }

      if (this.destin.value.type) {
        params.append('destinType', this.destin.value.type)
      }

      if (fullLink) {
        params.append('numAdt', this.paxSelector.adults)
        params.append('numChd', this.paxSelector.children)
        params.append('numInf', this.paxSelector.infants)
        params.append('tripType', this.tripType)
      }

      return url.toString() + params.toString()
    },
    $_fsfMixin_getReturnYearData(data) {
      new FlightSearchApi()
        .returnYearFlightPrices(data)
        .then((response) => this.$_fsfMixin_setYearPrices(response))
        .catch(() => this.$_fsfMixin_setYearPrices([]))
    },
    $_fsfMixin_getOnewayYearData(data) {
      new FlightSearchApi()
        .onewayYearFlightPrices(data)
        .then((response) => this.$_fsfMixin_setYearPrices(response))
        .catch(() => this.$_fsfMixin_setYearPrices([]))
    },
    $_fsfMixin_setYearPrices(prices) {
      this.$store.commit('fsf/setYearPrices', prices)
    },
    $_fsfMixin_setVouchers(vouchers) {
      if (!Array.isArray(vouchers)) {
        vouchers = vouchers.split(/(?:,|;)+/)
      }
      let promoCodes = []
      vouchers.forEach((voucher, index) => {
        promoCodes.push({
          index,
          code: voucher,
          error: ''
        })
      })

      this.$store.commit('eHorizonSearchForm/promoCodes/setPromoCodes', promoCodes)
    }
  }
}

export default FormMixin
